import UserProfileSkeleton from './UserProfileSkeleton';

export default UserProfileSkeleton;
